// extracted by mini-css-extract-plugin
export default {"cardBody":"cardBody-rIHsTr","header":"header-Lb7lkH","title":"title-oFuYLv","progress":"progress-keaivi","content":"content-aPEF1D","icon":"icon-jb2s9K"};